import { inject, computed, unref } from 'vue'

/** Provided by PublicRestaurantView: owner-only logo/banner editor on the public site. */
export const RMS_OWNER_LOGO_MODAL_KEY = Symbol('rmsOwnerLogoModal')

/**
 * @returns {{ canOpen: import('vue').ComputedRef<boolean>, openOwnerLogoModal: () => void }}
 */
export function usePublicOwnerLogoModal() {
  const ctx = inject(RMS_OWNER_LOGO_MODAL_KEY, null)
  const canOpen = computed(() => ctx != null && unref(ctx.enabled) === true)
  function openOwnerLogoModal() {
    ctx?.open?.()
  }
  return { canOpen, openOwnerLogoModal }
}
